import * as yup from 'yup';
import {
  CheckBoxDateAndTimeSchema,
  CheckboxWithTextSchema,
  SuggestionSchema,
} from '../../../common';
import { UpdateDoctorSchema } from './IDoctor';

export const DoctorsDiagnosisFormSchema = yup.object({
  doctors: yup.array(UpdateDoctorSchema).optional().default([]),
  apoplex: CheckBoxDateAndTimeSchema.optional().default(undefined),
  heartAttack: CheckBoxDateAndTimeSchema.optional().default(undefined),
  fracture: CheckBoxDateAndTimeSchema.optional().default(undefined),
  respiration: CheckboxWithTextSchema.optional().default(undefined),
  medicationAdministration: CheckboxWithTextSchema.optional().default(undefined),
  multiresistentGerm: CheckboxWithTextSchema.optional().default(undefined),
  infectiousDisease: CheckboxWithTextSchema.optional().default(undefined),
  dyingPhase: yup.boolean().notRequired().default(false),
  additionalDiagnoses: yup.string().notRequired().nullable().default(undefined),
  diabetesMellitus: yup.boolean().required().default(false),
  dementia: yup.boolean().required().default(false),
  parkinsons: yup.boolean().required().default(false),
  osteoporosis: yup.boolean().required().default(false),
  multipleSclerosis: yup.boolean().required().default(false),
  choreaHuntington: yup.boolean().required().default(false),
  malignantTumorDiseases: yup.boolean().required().default(false),
  tetraPlegiaOrTetraparesis: yup.boolean().required().default(false),
  apallicSyndrome: yup.boolean().required().default(false),
});
export type IDoctorsDiagnosisForm = yup.InferType<typeof DoctorsDiagnosisFormSchema>;

export const DoctorsDiagnosisCreateFormSchema = yup
  .object({
    residentId: yup.string().required(),
  })
  .concat(DoctorsDiagnosisFormSchema);
export type IDoctorsDiagnosisCreateForm = yup.InferType<typeof DoctorsDiagnosisCreateFormSchema>;

export const DoctorsDiagnosisUpdateFormSchema = yup
  .object({
    id: yup.string().required(),
  })
  .concat(DoctorsDiagnosisCreateFormSchema);
export type IDoctorsDiagnosisUpdateForm = yup.InferType<typeof DoctorsDiagnosisUpdateFormSchema>;

export const DoctorsDiagnosisSuggestionSchema = yup.object({
  additionalDiagnoses: SuggestionSchema.nullable(),
  respiration: SuggestionSchema.nullable(),
});

export type IDoctorsDiagnosisSuggestion = yup.InferType<typeof DoctorsDiagnosisSuggestionSchema>;
